import React from 'react'
import "./Banner.css"
import bannerImg1_1 from "./images/slider 11.png"
import bannerImg2 from "./images/44 new.png"
import bannerImg3 from "./images/ep-1.png"
import styled, { keyframes } from 'styled-components';
import { useNavigate } from 'react-router-dom'


// Text Animation



// Animation For 1st and 3rd Slide
const fadeInSlideIn = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-50%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

const fadeInSlideInBtn = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-40%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;


const AnimatedHeading = styled.h2`
  opacity: 0; /* Start invisible */
  animation: ${fadeInSlideIn} 1.5s ease-in-out forwards;
`;

const AnimatedParagraph = styled.p`
  opacity: 0; /* Start invisible */
  animation: ${fadeInSlideIn} 1.7s ease-in-out forwards;
`;

const AnimatedButton = styled.h2`
  opacity: 0; /* Start invisible */
  animation: ${fadeInSlideInBtn} 1.7s ease-in-out forwards;
`;


// Animation For 2nd Slide

const fadeInSlideIn2 = keyframes`
  0% {
    opacity: 0;
    transform: translateX(50%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

const fadeInSlideInBtn2 = keyframes`
  0% {
    opacity: 0;
    transform: translateX(30%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

const AnimatedHeading2 = styled.h2`
  animation: ${fadeInSlideIn2} 1.5s ease-in-out backwards;
`;

const AnimatedParagraph2 = styled.p`
  animation: ${fadeInSlideIn2} 1.7s ease-in-out backwards;
`;

const AnimatedButton2 = styled.p`
  animation: ${fadeInSlideInBtn2} 1.9s ease-in-out backwards;
`;

function Banner() {
  
  const navigate = useNavigate();

  return (
    <section id="carousel">
        <div id="carouselExampleIndicators" className="carousel slide carousel-fade" data-bs-ride="carousel">

          {/* Carousel Bottom Slider Buttons */}
            <div className="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
            </div>

            {/* Carousel */}
            <div className="carousel-inner banner">

              {/* First Slide */}
                <div className="carousel-item active" data-bs-interval="5000">
                    <div className='content'>
                        <div className="text-content">
                            <AnimatedHeading id='head1' className='animated h2'>BEST LOOKING AND INNOVATIVE HEADPHONES</AnimatedHeading>
                            <AnimatedParagraph className='p'>Best sounding<br />Crush your expectations</AnimatedParagraph>
                            <div className="cta"><AnimatedButton><button className='btn rounded-corners' onClick={() => navigate("/product/1")}>SHOP NOW</button></AnimatedButton></div>
                        </div>
                        <div className="banner1">
                            <img src={bannerImg1_1} className="banner-img1 d-block w-100" alt=" ..." />
                        </div>
                    </div>
                </div>

                {/* Second Slide */}
                <div className="carousel-item" data-bs-interval="5000">
                    <div className='content2'>
                        <div className="banner2">
                            <img src={bannerImg2} id='banner-img2' className="banner-img2 d-block w-100" alt=" ..." />
                        </div>
                        <div id="text-content2" className="text-content2">
                            <AnimatedHeading2 className='h2'>EXPERIENCE THE FUTURE OF FUTURE PROOF AUDIO</AnimatedHeading2>
                            <AnimatedParagraph2 className='p'>4K surround sound<br />Share the sound of summer</AnimatedParagraph2>
                            <div className="cta"><AnimatedButton2><button className='btn rounded-corners' onClick={() => navigate("/product/12")}>ORDER NOW</button></AnimatedButton2></div>
                        </div>
                    </div>
                </div>

                {/* Third Slide */}
                <div className="carousel-item" data-bs-interval="5000">
                    <div className='content content3'>
                        <div id="text-content3" className="text-content3">
                            <AnimatedHeading className='heading3 h2'>OUR BEST BUDS EVER</AnimatedHeading>
                            <AnimatedParagraph className='p para3' id='para3'>Live your vibe<br />Get better with time</AnimatedParagraph>
                            <div className="cta cta2"><AnimatedButton><button className='btn rounded-corners' onClick={() => navigate("/product/18")}>SHOP NOW</button></AnimatedButton></div>
                        </div>
                        <div className="banner3">
                            <img src={bannerImg3} id="carousel-img3" className="banner-img3 d-block w-100" alt="..." />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Banner